import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: resolve => { require(['@/views/pages/login/Login'], resolve) },
    },
    {
      path: '/',
      name: 'Monitoring',
      component: resolve => { require(['@/views/pages/monitoring/Monitoring'], resolve) },
    },
    {
      path: '/authentication',
      name: 'Authentication',
      component: resolve => { require(['@/views/pages/Authentication/index'], resolve) },
    },
    {
      path: '/authentication_idx',
      name: 'AuthenticationIdx',
      component: resolve => { require(['@/views/pages/login/idx'], resolve) },
    }
  ],
  mode: 'history'
})